import { Download } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';
import { FC } from 'react';
import { Button } from 'react-admin';
import { useUnitsCsvExport } from './useUnitsCsvExport';

const ExportUnitsCsvButton: FC = () => {
  const { handleExport, loading } = useUnitsCsvExport();

  return (
    <Button
      label="resources.units.list.export_csv"
      onClick={handleExport}
      disabled={loading}
      startIcon={loading ? <CircularProgress size={18} color="inherit" /> : <Download />}
    />
  );
};

export default ExportUnitsCsvButton;
